var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalBalanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 59,
    viewBox: "0 0 39 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4273 1.87724C22.1735 2.4224 20.8749 2.96683 19.4864 2.96683C18.0978 2.96683 16.799 2.42167 15.5454 1.87724C13.6492 1.06737 10.7684 -0.170374 9.08181 2.99689C7.15591 6.59047 8.26098 12.9091 12.5304 16.3705C14.6804 15.0598 17.024 14.3229 19.4873 14.3229C21.9506 14.3229 24.2942 15.059 26.4434 16.3705C30.7129 12.9093 31.8324 6.59066 29.892 2.99689C28.2047 -0.170319 25.3231 1.06741 23.4276 1.87724H23.4273Z",
    fill: "#FCD559"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5902 58.7601H17.394L17.3949 58.7599C11.6469 58.8143 6.67481 58.8423 3.57201 55.7945C1.61923 53.8951 0.677307 50.9984 0.677307 46.9534C0.677307 35.2831 8.75145 17.2728 19.4853 17.2721C30.2184 17.2721 38.2933 35.2832 38.2933 46.9534C38.2933 50.9982 37.3512 53.8951 35.4123 55.7945C32.6561 58.4868 28.4737 58.7737 23.5705 58.7737C22.92 58.7737 22.2551 58.7737 21.5902 58.7601ZM22.6111 34.475L19.9456 26.381L17.2801 34.475H8.65435L15.6327 39.4774L12.9672 47.5713L19.9456 42.569L26.9239 47.5713L24.2584 39.4774L31.2368 34.475H22.6111Z",
    fill: "#FCD559"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalBalanceIcon);
export default __webpack_public_path__ + "static/media/total-balance-icon.cccc68d122e86f69764d506d5342263b.svg";
export { ForwardRef as ReactComponent };